import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import axios from 'axios';
import Actions from './actions';
import { errorDuck } from '../error'; // Utilities
// import environment from '../../environments/qa';
// import environment from 'environment';

import * as UTIL from '../../util';
import { accountHelper, formatter, getLoyaltyStorage } from "../../util";
var Creators = Actions.Creators;
var changeInput = Creators.changeInput;
var requestWaitlist = Creators.request;
var response = Creators.response;
var available = Creators.available;
var status = Creators.status;
var toggleForm = Creators.toggleForm;
var cancel = Creators.cancel;
var checkin = Creators.checkin;
var reset = Creators.reset;
var toggleWaitlist = Creators.toggleWaitlist;
var toggleWaitListCheckInModalAction = Creators.toggleWaitListCheckInModal; // const storage = (typeof window !== 'undefined') ? JSON.parse(window.sessionStorage.getItem('cb-ds')) : {};

var addWaitlistUrl = UTIL.apiUtil.generateUrl('dinetime', 'addWaitlist');
var updateWaitlistUrl = UTIL.apiUtil.generateUrl('dinetime', 'updateWaitlist');
var getWaitlistStatusUrl = UTIL.apiUtil.generateUrl('dinetime', 'getWaitlistStatus');
var getWaitlistVisitUrl = UTIL.apiUtil.generateUrl('dinetime', 'getWaitlistStatusByVisit');
var cancelWaitlistStatusUrl = UTIL.apiUtil.generateUrl('dinetime', 'cancelWaitlistVisit');
var checkInWaitlistStatusUrl = UTIL.apiUtil.generateUrl('dinetime', 'checkInWaitList');
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;

function constructParams(state) {
  var _state$account, _loyaltyStorage$accou, _loyaltyStorage$accou2, _loyaltyStorage$accou3, _loyaltyStorage$accou4;

  var loyaltyStorage = getLoyaltyStorage(); // This is not ideal but works and quick easy solution

  var account = accountHelper(state === null || state === void 0 ? void 0 : (_state$account = state.account) === null || _state$account === void 0 ? void 0 : _state$account.aadResponse);
  var firstName = (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.FirstName) || '';
  var lastName = (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou2 = loyaltyStorage.account) === null || _loyaltyStorage$accou2 === void 0 ? void 0 : _loyaltyStorage$accou2.LastName) || '';
  var phoneNumber = (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou3 = loyaltyStorage.account) === null || _loyaltyStorage$accou3 === void 0 ? void 0 : _loyaltyStorage$accou3.HomePhone) ? formatter.phone(loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou4 = loyaltyStorage.account) === null || _loyaltyStorage$accou4 === void 0 ? void 0 : _loyaltyStorage$accou4.HomePhone) : '';
  var emailAddress = typeof (account === null || account === void 0 ? void 0 : account.emails) !== 'undefined' ? account === null || account === void 0 ? void 0 : account.emails[0] : account === null || account === void 0 ? void 0 : account.email;
  var params = {
    PartySize: state.waitlist.partySize,
    FirstName: state.waitlist.firstName || firstName,
    LastName: state.waitlist.lastName || lastName,
    PhoneNumber: state.waitlist.phoneNumber || phoneNumber
  };

  if (state.waitlist.newsletter) {
    params.EmailAddress = state.waitlist.emailAddress || emailAddress;
    params.ZipCode = state.waitlist.zipCode;
    params.Newsletter = 'yes';
  }

  return params;
}

function fetchWaitlist(state) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var url;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch(requestWaitlist());
              url = addWaitlistUrl.replace('{siteId}', state.location.waitlistId); // Post by current location id

              return _context.abrupt("return", axios({
                method: 'post',
                headers: UTIL.apiUtil.setHeaders(),
                params: constructParams(state),
                url: url
              }).then(function (json) {
                return dispatch(response(json, state.location.waitlistId));
              }).catch(function (err) {
                dispatch(reset());
                var errorState = UTIL.buildError(err);

                if (UTIL.mobileAppUtil.isMobileApp()) {
                  errorState.display = 'modal';
                  return dispatch(receiveError(errorState));
                } else {
                  return dispatch(receiveError(errorState));
                }
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function fetchWaitlistUpdate(state) {
  return function (dispatch) {
    dispatch(requestWaitlist());
    var url = updateWaitlistUrl.replace('{siteId}', state.waitlist.storeId) // Cancel by stored waitlist location id
    .replace('{visitId}', state.waitlist.confirmation);
    return axios({
      method: 'patch',
      headers: UTIL.apiUtil.setHeaders(),
      params: constructParams(state),
      url: url
    }).then(function (json) {
      return dispatch(response(json, state.location.waitlistId));
    }).catch(function (err) {
      dispatch(reset());
      dispatch(receiveError(UTIL.buildError(err)));
    });
  };
}

function fetchWaitlistStatus(state) {
  return function (dispatch) {
    if (!state.waitlist.confirmation) {
      return dispatch(receiveError({
        code: 'internal',
        message: 'No wait list confirmation id'
      }));
    }

    dispatch(requestWaitlist());
    var url = getWaitlistVisitUrl.replace('{siteId}', state.waitlist.storeId) // Check by stored waitlist location id
    .replace('{visitId}', state.waitlist.confirmation);
    return axios({
      method: 'get',
      headers: UTIL.apiUtil.setHeaders(),
      url: url
    }).then(function (json) {
      return dispatch(status(json));
    }).catch(function (err) {
      var _err$response;

      if ((err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 410) {
        alert('There is an issue with your spot on the Wait List. Please visit the host stand to be seated');
        dispatch(cancel()); // dispatch(receiveError({
        //   title: 'Error',
        //   body:  'There is an issue with your spot on the Wait List. Please visit the host stand to be seated',
        //   display: 'modal',
        //   category: '',
        //   type: 'error'
        // }))
      }

      dispatch(receiveError(err));
    });
  };
}

function fetchWaitlistCancel(state) {
  return function (dispatch) {
    if (!state.waitlist.confirmation) {
      return dispatch(receiveError({
        code: 'internal',
        message: 'No wait list confirmation id'
      }));
    }

    dispatch(requestWaitlist());
    var url = cancelWaitlistStatusUrl.replace('{siteId}', state.waitlist.storeId) // Cancel by stored waitlist location id
    .replace('{visitId}', state.waitlist.confirmation);
    return axios({
      method: 'post',
      headers: UTIL.apiUtil.setHeaders(),
      url: url
    }).then(function (json) {
      dispatch(cancel(json));
      var message = UTIL.buildInternalError('cb6001');
      dispatch(receiveError(UTIL.buildError(message)));
    }).catch(function (err) {
      dispatch(receiveError(err));
    });
  };
}

function fetchWaitlistCheckIn(state) {
  return function (dispatch) {
    if (!state.waitlist.confirmationNumber) {
      return dispatch(receiveError({
        title: 'Error',
        body: 'You must join the waitlist before you can check in',
        display: 'inplace',
        category: '',
        type: 'error'
      }));
    } // if(state.location.location?.EnableWaitlistCheckin){
    //   return dispatch(receiveError({
    //     title: '',
    //     body: 'This location does not support waitlist check-in feature',
    //     display: 'inplace',
    //     category: '',
    //     type: 'error'
    //   }))
    // }


    if (state.waitlist.isCheckIn) {
      return dispatch(receiveError({
        code: 'Error',
        message: 'You have already checked-in'
      }));
    }

    var closestStore = window.appUtil.getClosestStoreAsync().then(function (apiResponse) {
      if (apiResponse.success) {
        var url = checkInWaitlistStatusUrl.replace('{confirmationNumber}', state.waitlist.confirmationNumber);
        return axios({
          method: 'post',
          headers: UTIL.apiUtil.setHeaders(),
          url: url
        }).then(function (apiResponse) {
          var newState = _objectSpread({}, apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data);

          dispatch(checkin(newState));
          alert('You have successfully checked in');
          dispatch(toggleWaitListCheckInModalAction(false));
        }).catch(function (err) {
          var errorTitle = 'Error';

          if (err.response) {
            console.log('ERROR MESSAGE BODY ', err.response);

            if (err.response.data.isUserCheckedIn) {
              dispatch(checkin(_objectSpread({}, err.response.data)));
            } else {
              var _err$response2, _err$response2$data;

              if ((err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : _err$response2$data.errorMessage) == "Sorry, your waitlist request has expired") {
                // TODO :: update error message in azure function so it not h
                errorTitle = 'Error';
                err.response.data.errorMessage = 'There is an issue with your spot on the Wait List. Please visit the host stand to be seated';
                dispatch(cancel());
              }

              dispatch(receiveError({
                title: errorTitle,
                body: err.response.data.errorMessage,
                display: 'modal',
                category: '',
                type: 'error'
              }));
            }
          }
        });
      } else {
        dispatch(receiveError({
          title: 'Error',
          body: 'You must be at the store to check-in',
          display: 'modal',
          category: '',
          type: 'error'
        }));
      }
    }).catch(function (err) {
      console.error('failed to get closest store ', err);
      dispatch(receiveError({
        title: 'Error',
        body: 'You must be at the store to check-in',
        display: 'modal',
        category: '',
        type: 'error'
      }));
    });
  };
}

function fetchWaitlistAvailable(state) {
  return function (dispatch) {
    // dispatch(requestWaitlist()); // Silent request. No update on loading states
    if (!state.location.waitlistId) {
      dispatch(receiveError({
        title: 'Error',
        body: 'Waitlist Id not found',
        display: 'modal',
        category: '',
        type: 'error'
      }));
      return;
    }

    var url = getWaitlistStatusUrl.replace('{siteId}', state.location.waitlistId); // Check by current location id

    return axios({
      method: 'get',
      headers: UTIL.apiUtil.setHeaders(),
      params: {
        PartySize: state.waitlist.partySize || 1 // Default party size to the minimum number

      },
      url: url
    }).then(function (json) {
      return dispatch(available(json));
    }).catch(function (err) {
      dispatch(receiveError({
        title: 'Error',
        body: 'Waitlist Id not found',
        display: 'modal',
        category: '',
        type: 'error'
      }));
    });
  };
}

function setWaitlistAvailableQSR(waitlistId, callback) {
  var partySize = JSON.parse(sessionStorage.getItem('persist:cb-ds-wait'));

  if (!waitlistId) {
    return;
  }

  var url = getWaitlistStatusUrl.replace('{siteId}', waitlistId); // Check by current location id

  return axios({
    method: 'get',
    headers: UTIL.apiUtil.setHeaders(),
    params: {
      PartySize: parseInt(partySize === null || partySize === void 0 ? void 0 : partySize.partySize) || 1 // Default party size to the minimum number

    },
    url: url
  }).then(function (json) {
    callback(json.data.results);
    return json.data.results;
  }).catch(function (err) {// dispatch(receiveError(err)); TODO: Log result
  });
}

function fetchWaitlistAvailableQSR(state, waitlistId) {
  if (!waitlistId) {
    return;
  }

  return function (dispatch) {
    var _state$waitlist;

    var url = getWaitlistStatusUrl.replace('{siteId}', waitlistId); // Check by current location id

    return axios({
      method: 'get',
      headers: UTIL.apiUtil.setHeaders(),
      params: {
        PartySize: ((_state$waitlist = state.waitlist) === null || _state$waitlist === void 0 ? void 0 : _state$waitlist.partySize) || 1 // Default party size to the minimum number

      },
      url: url
    }).then(function (json) {
      return json.data.results;
    }).catch(function (err) {// dispatch(receiveError(err)); TODO: Log result
    });
  };
}

var postWaitlist = function postWaitlist() {
  return function (dispatch, getState) {
    return dispatch(fetchWaitlist(getState()));
  };
};

var updateWaitlist = function updateWaitlist() {
  return function (dispatch, getState) {
    return dispatch(fetchWaitlistUpdate(getState()));
  };
};

var checkWaitlistAvailable = function checkWaitlistAvailable() {
  return function (dispatch, getState) {
    return dispatch(fetchWaitlistAvailable(getState()));
  };
};

var checkWaitlistAvailableQSR = function checkWaitlistAvailableQSR(value) {
  return function (dispatch, getState) {
    return dispatch(fetchWaitlistAvailableQSR(getState, value));
  };
};

var getWaitlist = function getWaitlist() {
  return function (dispatch, getState) {
    return dispatch(fetchWaitlistStatus(getState()));
  };
};

var cancelWaitlist = function cancelWaitlist() {
  return function (dispatch, getState) {
    return dispatch(fetchWaitlistCancel(getState()));
  };
};

var checkInWaitList = function checkInWaitList() {
  return function (dispatch, getState) {
    return dispatch(fetchWaitlistCheckIn(getState()));
  };
};

var toggleWaitListCheckInModal = function toggleWaitListCheckInModal(show) {
  return function (dispatch, getState) {
    var toggleFunc = function toggleFunc(state, show) {
      return function (dispatch) {
        return dispatch(toggleWaitListCheckInModalAction(show));
      };
    };

    return dispatch(toggleFunc(getState(), show));
  };
};

export default {
  toggleForm: toggleForm,
  toggleWaitlist: toggleWaitlist,
  changeInput: changeInput,
  postWaitlist: postWaitlist,
  updateWaitlist: updateWaitlist,
  getWaitlist: getWaitlist,
  cancelWaitlist: cancelWaitlist,
  checkWaitlistAvailable: checkWaitlistAvailable,
  checkWaitlistAvailableQSR: checkWaitlistAvailableQSR,
  checkInWaitList: checkInWaitList,
  toggleWaitListCheckInModal: toggleWaitListCheckInModal,
  setWaitlistAvailableQSR: setWaitlistAvailableQSR
};